@if (canShow) {
  <qima-button
    data-cy="leader-field-mode-btn"
    (qimaButtonClick)="switchToFieldMode()"
    [qimaButtonIsDisabled]="isSwitching"
    [qimaButtonSize]="buttonSizes.SMALL"
    [qimaButtonStyle]="buttonStyles.SECONDARY"
    [qimaButtonLabel]="'leader-field-mode.open-inspector-app' | translate"
  ></qima-button>
}
